export const capabilitiesEndpoint = state => `${state.config.apiUrl}/v1/capabilities`;

export const updateCapabilityEndpoint = (state, payload) => (
    `${state.config.apiUrl}/v1/capability/${payload.capabilityGroupId}`
);
export const getCapabilityEndpoint = (state, payload) => (
    `${state.config.apiUrl}/v1/capability/${payload.capabilityGroupId}`
);



// WEBPACK FOOTER //
// ./src/services/capabilities/selectors.js